export default __webpack_public_path__ + "conection_error.a8dd4f0.svg";